/**
 * Location Service
 * Provides default world map view for all users
 */

import { getProperty } from '../fsConfig';
import { get } from './commonFetch';

// Default world map coordinates (center of world with good global view)
const DEFAULT_COORDINATES: [number, number] = [0, 0]; // Perfect center at Greenwich longitude and Equator

// Legacy function - no longer used since we always return world view
const getUserCountry = (): string | null => {
  return null; // Always return null to use default world view
};

/**
 * Fetches user location from server API
 * @returns Promise with user location data
 */
export const fetchUserLocation = async () => {
  try {
    const response = await get<{
      countryCode: string;
      countryName: string;
      coordinates: [number, number];
      zoom: number;
      detectedFrom: string;
      supportedSMSCountryCodes: string[];
      accountName: string;
    }>('/api/user/location');
    
    return response;
  } catch (error) {
    console.error('Error fetching user location from server:', error);
    return {
      countryCode: 'WORLD',
      countryName: 'World Map',
      coordinates: DEFAULT_COORDINATES,
      zoom: 0.5,
      detectedFrom: 'error_fallback',
      supportedSMSCountryCodes: [],
      accountName: ''
    };
  }
};

/**
 * Gets the default world map center coordinates
 * @returns [longitude, latitude] coordinates for map center
 */
export const getMapCenterCoordinates = (): [number, number] => {
  console.log('Using default world map center coordinates', DEFAULT_COORDINATES);
  return DEFAULT_COORDINATES;
};

/**
 * Gets the default world map zoom level
 * @returns zoom level number for world view
 */
export const getMapZoomLevel = (): number => {
  return 0.5; // Extremely low zoom level to guarantee entire world is visible
};

/**
 * Gets default world map information for display
 * @returns Object with world map details
 */
export const getUserCountryInfo = () => {
  return {
    code: 'WORLD',
    name: 'World Map',
    coordinates: DEFAULT_COORDINATES
  };
};
